/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      route — private-lesson instructor detail page
 *   extends:   Route
 *   template:  none
 *   model:     passes params straight through
 *   key:       model, setupController, resetController
 *   uses:      controller.loadInstructorTask
 *   siblings:  controllers/ski-instructor.js
 *   tests:     tests/unit/routes/simple-routes-test.js
 *
 * Ski-instructor detail route for the e-commerce storefront.
 */
import Route from '@ember/routing/route';

export default class SkiInstructorRoute extends Route {
  model(params) {
    return params;
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    controller.loadInstructorTask.perform();
    controller.setProperties({
      instructor_id: model.id,
    });
  }

  resetController(controller) {
    controller.loadInstructorTask.cancelAll();
  }
}
